<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <groupsidebar></groupsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <reporting v-if="users!==null&&groups!==null" :poolID="PoolID" :users="users" :groups="groups" :tags="tags" :ClientID="ClientID" :isgroup="true" :hasEmail="hasEmail"></reporting>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import groupsidebar from "../../layout/Group/Sidebar.vue"
  import reporting from "../../components/Reporting.vue"

  export default {
    name: 'GroupReporting',
    components: {acheader,acfooter,groupsidebar,reporting},
    data() {
      return {
        PoolID:null,
        users:null,
        groups:null,
        tags:null,
        hasEmail:null,
        ClientID:null
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapGroup(this.$route.params.id);
        this.apiCommand([
           {
             Operation: "LicensePool",
             Function: "GetGroupUsers",
             Fields: {
               LicensePoolID: this.sdata.activegroup.LicensePoolID,
               GroupID: this.$route.params.id
             }
          },
          {
            Operation: "LicensePool",
            Function: "GetGroupSubGroups",
            Fields: {
              LicensePoolID: this.sdata.activegroup.LicensePoolID,
              GroupID: this.$route.params.id
            }
          },
          {
            Operation: "Client",
            Function: "GetClientByID",
            Fields: {
              ClientID: this.udata.ClientID
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetTags",
            Fields: {
              LicensePoolID: this.sdata.activegroup.LicensePoolID
            }
          }
        ]).then(r=>{
          var cr=JSON.parse(r.CommandResult);
          var cli = JSON.parse(cr.returnObjects[2].returnObject);
          this.hasEmail=cli.EmailAddress!==null&&cli.EmailAddress.length>0;
          this.ClientID=this.udata.ClientID;
          this.PoolID=this.sdata.activegroup.LicensePoolID;
          this.users = JSON.parse(cr.returnObjects[0].returnObject);
          this.groups = JSON.parse(cr.returnObjects[1].returnObject);
          this.tags = JSON.parse(cr.returnObjects[3].returnObject);
        });
      });
    }
  }
</script>
